import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LigacaoTelemarketing } from 'src/app/models/ligacao-telemarketing';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { LigacaoService } from 'src/app/services/ligacao.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-ligacao-modal',
  templateUrl: './ligacao-modal.component.html',
  styleUrls: ['./ligacao-modal.component.scss']
})
export class LigacaoModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  ligacao: LigacaoTelemarketing;
  idLigacao: number;

  constructor(public dialogRef: MatDialogRef<LigacaoModalComponent>, private ligacaoService: LigacaoService, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private utilitarioService: UtilitarioService,
    private globalService: GlobalService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.idLigacao = data.idLigacao;
  }

  ngOnInit(): void {
    this.buscarLigacao();
  }

  voltar() {
    this.dialogRef.close();
  }

  buscarLigacao() {
    this.carregandoService.mostra('buscarLigacao');
    this.ligacaoService.consultarPorId(this.idLigacao).subscribe(
      (retorno) => {
        this.ligacao = retorno;
        this.carregandoService.esconde('buscarLigacao');
      },
      (erro) => {
        this.carregandoService.esconde('buscarLigacao');
        this.notificacaoService.erro(erro);
      }
    );
  }

}
